import { render } from "./App.vue?vue&type=template&id=b668bb4e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b668bb4e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\galita-api\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__